import HOSTS from '@/constants/hosts';
import { KustomerBaseUrl } from '@/constants/kustomerUrls';

const getKustomerBaseUrl = (host: string) =>
  host === HOSTS['production'] ? KustomerBaseUrl.Production : KustomerBaseUrl.Staging;

export const kustomerEventLink = ({
  host,
  kustomerId,
  personKustomerId
}: {
  host: string;
  kustomerId: string;
  personKustomerId: string;
}) => {
  return `${getKustomerBaseUrl(host)}/app/customers/${personKustomerId}/event/${kustomerId}`;
};

export const kustomerConversationLink = ({
  host,
  conversationKustomerId
}: {
  host: string;
  conversationKustomerId: string;
}) => {
  return `${getKustomerBaseUrl(host)}/app/conversations/${conversationKustomerId}`;
};

export const kustomerPersonLink = ({
  host,
  personKustomerId
}: {
  host: string;
  personKustomerId: string;
}) => {
  return `${getKustomerBaseUrl(host)}/app/customers/${personKustomerId}`;
};
